import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { locale as italian } from "../../../../../i18n/it";
import { RequestService } from "../../../requests/request.service";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";

@Component({
  selector: "app-suitables-candidate-list",
  templateUrl: "./suitables-candidate-list.component.html"
})
export class SuitablesCandidateListComponent implements OnInit {
  public candidate_list: any = [];
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public searchStatus: number = 7;
  public step_status_filter: { name: string, value: number }[] = [
    { name: "STATUS_STEP_SINGULAR.STEP_0", value: 0 },
    { name: "STATUS_STEP_SINGULAR.STEP_1", value: 1 },
    { name: "STATUS_STEP_SINGULAR.STEP_2", value: 2 },
    { name: "STATUS_STEP_SINGULAR.STEP_3", value: 3 },
    { name: "STATUS_STEP_SINGULAR.STEP_4", value: 4 },
    { name: "STATUS_STEP_SINGULAR.STEP_5", value: 5 },
    { name: "STATUS_STEP_SINGULAR.STEP_6", value: 6 }
  ];
  public requestStatusFilter: number = 0;

  recruiterList: { hash: string; complete_name: string }[] = [];
  requestsList: string[] = [];
  commercialList: { hash: string; complete_name: string }[] = [];

  recruiterFilter: { hash: string, complete_name: string } = { hash: null, complete_name: null };
  filteredItems: any = [];
  filteredFrom: string = moment().startOf("year").format("YYYY-MM-DD");
  filteredTo: string = moment().format("YYYY-MM-DD");
  filterRequest: string = "0";
  filterCommercial: { hash: string, complete_name: string } = { hash: null, complete_name: null };

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _requestService: RequestService,
    public _router: Router,
    public _userService: UserService
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.CANDIDATES_PROPOSED,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.RECRUITMENT,
            isLink: false
          },
          {
            name: italian.data.MENU.CANDIDATES_PROPOSED,
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_request_suitable_candidate_list")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.recruiterList = await this._userService.getRecruiterList();
    this.commercialList = await this._userService.getCommercialList();

    await this.loadEligibleCandidate();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadEligibleCandidate() {
    this._utilService.showLoading();
    this.candidate_list = await this._requestService.getEligibleUsers(this.filteredFrom, this.filteredTo);
    const step_colors: string[] = ["secondary", "warning", "info", "info", "danger", "success", "primary"];
    this.candidate_list.map(async (item: any) => {
      item.label_step = `STATUS_STEP_SINGULAR.STEP_${item.data.step}`;
      item.color_step = step_colors[item.data.step];

      if (!this.requestsList.find((request) => request === item.request_name)) {
        this.requestsList.push(item.request_name);
      }
    });
    this.filteredCandidateList();

    this._utilService.hideLoading();
  }

  filteredCandidateList() {
    let items: any = this.candidate_list;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.user.complete_name.toLowerCase().includes(keywords) || item.request_name.toLowerCase().includes(keywords));
    }

    if (this.recruiterFilter && !!this.recruiterFilter.hash) {
      items = items.filter((item: any) => item.data.creator_hash === this.recruiterFilter.hash);
    }

    const requestStatusFilter = Number(this.requestStatusFilter);
    if (requestStatusFilter >= 0) {
      items = items.filter((item: any) => Boolean(requestStatusFilter) === item.closed);
    }

    if (this.filterRequest && this.filterRequest !== "0") {
      items = items.filter((item: any) => item.request_name === this.filterRequest);
    }

    if (this.searchStatus < 7) {
      items = items.filter((item: any) => Number(item.data.step) === Number(this.searchStatus));
    }

    if (this.filterCommercial && !!this.filterCommercial.hash) {
      items = items.filter((item: any) => item.commercial.hash === this.filterCommercial.hash);
    }

    this.filteredItems = items;
  }
}
